<template>
  <div class="order-submission">
    <div class="allAddress">
      <div class="nav acea-row">
        <div
          class="item font-color-red"
          :class="shipping_type === 0 ? 'on' : 'on2'"
          @click="addressType(0)"
        ></div>
      </div>
      <div
        class="address acea-row row-between-wrapper"
        v-if="shipping_type === 0"
        @click="addressTap"
      >
        <div class="addressCon" v-if="addressInfo.real_name">
          <div class="name">
            {{ addressInfo.real_name }}
            <span class="phone">{{ addressInfo.phone }}</span>
          </div>
          <div>
            <span class="default font-color-red" v-if="addressInfo.is_default"
              >[默认]</span
            >
            {{ addressInfo.province }}{{ addressInfo.city
            }}{{ addressInfo.district }}{{ addressInfo.detail }}
          </div>
        </div>
        <div class="addressCon" v-else>
          <div class="setaddress">设置收货地址</div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div class="address acea-row row-between-wrapper" v-else>
        <div class="addressCon">
          <div class="name">
            {{ system_store.name }}
            <span class="phone">{{ system_store.phone }}</span>
          </div>
          <div>{{ system_store._detailed_address }}</div>
        </div>
      </div>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>
    <div class="limitArea" v-if="limit_area != ''">
      <div style=" width: 21%;color: #e93323;">
        配送提示：
      </div>
      <div style="width: 80%;">当前套餐不支持{{ limit_area }}区域下单</div>
    </div>
    <div class="wrapper">
      <div class="item">
        <div>套餐类型</div>
        <div class="list">
          <div
            class="SelectItem acea-row row-middle"
            :class="index === navActive ? 'on' : ''"
            v-for="(item, index) in goodsType"
            :key="index"
            @click="asideTap(index)"
            style="padding: 10px;"
          >
            <div class="name acea-row row-center-wrapper">
              {{ item.type_name }}
            </div>
            <div class="tip">
              <div v-for="(text, index) in item.info" :key="index + 'text'">
                {{ text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="item acea-row row-between-wrapper" v-if="shipping_type === 0">
        <div>快递费用</div>
        <div class="discount">免运费</div>
      </div>
      <div v-else>
        <div class="item acea-row row-between-wrapper">
          <div>联系人</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系姓名"
              v-model="contacts"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>联系电话</div>
          <div class="discount">
            <input
              type="text"
              placeholder="请填写您的联系电话"
              v-model="contactsTel"
            />
          </div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>紧急联系人</div>
        <div class="discount">
          <input
            style="text-align: right;"
            type="text"
            placeholder="请填写紧急联系人电话"
            v-model="emergency_phone"
          />
        </div>
      </div>
      <div class="item">
        <div>备注信息</div>
        <textarea
          placeholder="请添加备注（150字以内）"
          v-model="mark"
        ></textarea>
      </div>
    </div>

    <div style="height:1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div class="settlement2" @click="createOrder">提交订单</div>
    </div>
    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.total_price"
      :checked="usableCoupon.id"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>
<style scoped>
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}
.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}
.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #222222 0%, #f5f5f5 100%);
  background-image: -webkit-linear-gradient(
    to bottom,
    #222222 0%,
    #f5f5f5 100%
  );
  background-image: -moz-linear-gradient(to bottom, #222222 0%, #f5f5f5 100%);
  padding-top: 1rem;
}
.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .allAddress .nav .item {
  width: 3.55rem;
}
.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}
.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "麦麦配送";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}
.order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
}
.order-submission .allAddress .nav .item.on2 {
  position: relative;
}
.order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
}
.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "麦麦配送";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}
.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}
.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}
.limitArea {
  padding: 0.3rem;
  display: flex;
  background-color: #fff;
}
</style>
<script>
// import OrderGoods from "@components/OrderGoods";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import { postOrderConfirm, postOrderComputed } from "@api/order";
import { mapGetters } from "vuex";
// import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";
import { postGoodsCardType, submitGoodsCard } from "@api/user";
const _isWeixin = isWeixin();
export default {
  // name: NAME,
  components: {
    // OrderGoods,
    CouponListWindow,
    AddressWindow
  },
  props: {},
  data: function() {
    return {
      emergency_phone: "",
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      active: _isWeixin ? "weixin" : "yue",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        pay_price: "计算中"
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      goodsType: {},
      limit_area: "",
      navActive: 0
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {},
  mounted: function() {
    let that = this;
    // that.getCartInfo();
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;
  },
  created() {
    this.getGoodsType();
  },
  methods: {
    addressType: function(index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("暂无门店信息，您无法选择到店自提！");
      this.shipping_type = index;
    },

    getGoodsType() {
      this.limit_area =
        this.$route.query.l && this.$route.query.l.length
          ? this.$route.query.l.join("、")
          : "";
      let data = {
        group_id: this.$route.query.t,
        number: this.$route.query.u,
        password: this.$route.query.p,
        goodList: this.$route.query.g
      };
      console.log("111111", data);
      let that = this;
      postGoodsCardType(data)
        .then(function(response) {
          console.log("22222", response);
          response.data.forEach(item => {
            item.info = item.info.split("<br/>");
          });
          that.goodsType = response.data.filter(
            item => item.goods_id == data.goodList
          );
        })
        .catch(function(e) {
          console.log(e);
        });
    },
    computedPrice() {
      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type) + 1
      }).then(res => {
        const data = res.data;
        if (data.status === "EXTEND_ORDER") {
          this.$router.replace({
            path: "/order/detail/" + data.result.orderId
          });
        } else {
          this.orderPrice = data.result;
        }
      });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds)
        .then(res => {
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.system_store || {};
          this.store_self_mention = res.data.store_self_mention;
          this.computedPrice();
        })
        .catch(() => {
          this.$dialog.error("加载订单数据失败");
        });
    },
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      this.showCoupon = true;
    },
    changeCoupon: function(coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      this.active = index;
    },

    asideTap: function(index) {
      this.navActive = index;
      // this.$dialog.toast({ mes: "选择:"+index });
      console.log(index);
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
    },
    createOrder() {
      if (!this.addressInfo.id && !this.shipping_type)
        return this.$dialog.toast({ mes: "请选择收货地址" });
      if (!this.emergency_phone) {
        return this.$dialog.toast({ mes: "请输入紧急联系人电话" });
      } else {
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.emergency_phone)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
      }

      if (this.shipping_type) {
        if (
          (this.contacts === "" || this.contactsTel === "") &&
          this.shipping_type
        )
          return this.$dialog.toast({ mes: "请填写联系人或联系人电话" });
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          return this.$dialog.toast({ mes: "请填写正确的手机号" });
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$dialog.toast({ mes: "请填写您的真实姓名" });
        }
      }

      let that = this;
      if (this.goodsType[this.navActive].id.length == 0) {
        that.$dialog.loading.close();
        that.$dialog.toast({ mes: "套餐类型错误，请检查后重试！" });
      } else {
        let data = {
          group_id: this.$route.query.t,
          number: this.$route.query.u,
          password: this.$route.query.p,
          type_id: this.goodsType[this.navActive].id,
          addressId: this.addressInfo.id,
          goods_id: this.$route.query.g,
          mark: this.mark,
          emergency_phone: this.emergency_phone
        };
        const address = this.addressInfo;
        this.$dialog.confirm({
          mes: `<div>收件人：${address.real_name}</div><div>收件电话：${
            address.phone
          }</div><div>收件地址：${address.province}${address.city}${
            address.district
          }${address.detail}</div>`,
          title: "请您核实收件信息",
          opts: [
            {
              txt: "确认",
              color: false,
              callback: () => {
                this.$dialog.loading.open("生成订单中");
                submitGoodsCard(data)
                  .then(function(response) {
                    console.log("opop", response.data.order_id);
                    that.$dialog.loading.close();
                    that.$dialog.toast({
                      mes: "兑换成功，我们将尽快为您排单发货。"
                    });
                    that.$router.replace({
                      path: "/order/detail/" + response.data.order_id
                    });
                  })
                  .catch(function(e) {
                    that.$dialog.loading.close();
                    console.log(e);
                    that.$dialog.toast({ mes: "兑换失败，" + e.msg });
                  });
              }
            },
            {
              txt: "重新填写",
              color: false,
              callback: () => {
                this.addressTap();
              }
            }
          ]
        });
      }
    }
  }
};
</script>
